import { useTranslations } from "next-intl";

export const currentYear = new Date().getFullYear();

export const academicYearList = Array.from({ length: 5 }, (value, index) => new Date().getFullYear() + index);

export function getMonthList(message: typeof useTranslations): { text: string; value: string }[] {
  const translate = message(`Contact`);

  return [
    {
      text: translate(`monthesList.january`),
      value: `0`
    },
    {
      text: translate(`monthesList.february`),
      value: `1`
    },
    {
      text: translate(`monthesList.march`),
      value: `2`
    },
    {
      text: translate(`monthesList.april`),
      value: `3`
    },
    {
      text: translate(`monthesList.may`),
      value: `4`
    },
    {
      text: translate(`monthesList.june`),
      value: `5`
    },
    {
      text: translate(`monthesList.july`),
      value: `6`
    },
    {
      text: translate(`monthesList.august`),
      value: `7`
    },
    {
      text: translate(`monthesList.september`),
      value: `8`
    },
    {
      text: translate(`monthesList.october`),
      value: `9`
    },
    {
      text: translate(`monthesList.november`),
      value: `10`
    },
    {
      text: translate(`monthesList.december`),
      value: `11`
    }
  ];
}

export function getSubjectList(message: typeof useTranslations): { text: string; value: string }[] {
  const translate = message(`Contact`);

  return [
    {
      text: translate(`subjectList.accounting`),
      value: `Economics, Accounting and Finance`
    },
    {
      text: translate(`subjectList.socialSciences`),
      value: `Social Sciences and Humanities`
    },
    {
      text: translate(`subjectList.business`),
      value: `Business and Management`
    },
    {
      text: translate(`subjectList.arts`),
      value: `Arts`
    },
    {
      text: translate(`subjectList.computing`),
      value: `Computing and Information Systems`
    },
    {
      text: translate(`subjectList.sciences`),
      value: `Science`
    },
    {
      text: translate(`subjectList.engineering`),
      value: `Engineering`
    },
    {
      text: translate(`subjectList.other`),
      value: ``
    }
  ];
}
